import React, { Fragment, Component } from 'react'
import { NavLink } from 'react-router-dom'
import { isMobile } from 'react-device-detect'
import UsersList from './users/UsersList'
import { connect } from './helpers/links'
import { getRandomNumber } from './helpers/functions'
import { Spacecadet } from './helpers/Star'

class Users extends Component {
  constructor(tweets) {
    super(tweets)
    this.state = {
      tweets: tweets.tweets,
      mapped: null,
    }
  }

  componentDidMount() {
    // createStars(1, 100)
    // createStars(2, 85)
    // createStars(3, 100)
    //
    // scroll to middle
    // const width = document.getElementById('universe').offsetWidth
    // const height = document.getElementById('universe').offsetHeight
    // const startPointX = Math.ceil(width * 0.25)
    // const startPointY = Math.ceil(height * 0.4)
    // window.scroll(startPointX, startPointY)
  }

  render() {
    let containerHeight
    if (isMobile) {
      containerHeight = 1200
    } else {
      containerHeight = 1600
    }
    const containerHeightStyle = {
      height: `${containerHeight}vh`,
    }

    const noOverlap = []

    return (
      <Fragment>
        <div className="universe" id="universe">
          <div className="header">
            <div className="twitterverse_title-container">
              <h2>The Twitterverse</h2>
            </div>
            <div className="twitterverse_button-container">
              <NavLink to={connect} className="button twitterverse_make-your-own">
                Make Your Own
              </NavLink>
            </div>
            <Spacecadet />
          </div>
          <div className="star_container" id="star_container" style={containerHeightStyle}>
            {this.state.tweets.map((star, index) => {
              let topPos
              let leftPos
              let posArray
              function density() {
                topPos = getRandomNumber(10, containerHeight)
                leftPos = getRandomNumber(0, 90)
                posArray = [topPos, leftPos]
                if (
                  noOverlap.indexOf([posArray[0] - 2, posArray[1] - 2]) !== -1 &&
                  noOverlap.indexOf([posArray[0] - 1, posArray[1] - 1]) !== -1 &&
                  noOverlap.indexOf([posArray[0] + 1, posArray[1] + 1]) !== -1 &&
                  noOverlap.indexOf([posArray[0] + 2, posArray[1] + 2]) !== -1 &&
                  noOverlap.indexOf([posArray[0] - 1, posArray[1] + 1]) !== -1 &&
                  noOverlap.indexOf([posArray[0] - 2, posArray[1] + 2]) !== -1 &&
                  noOverlap.indexOf([posArray[0] + 1, posArray[1] - 1]) !== -1 &&
                  noOverlap.indexOf([posArray[0] + 2, posArray[1] - 2]) !== -1 &&
                  noOverlap.indexOf([posArray[0] + 1, posArray[1] - 1]) !== -1 &&
                  noOverlap.indexOf([posArray[0] - 2, posArray[1] + 2]) !== -1 &&
                  noOverlap.indexOf([posArray[0] - 1, posArray[1] + 1]) !== -1 &&
                  noOverlap.indexOf([posArray[0] + 2, posArray[1] - 2]) !== -1 &&
                  noOverlap.indexOf(posArray) !== -1
                ) {
                  // console.log(`⚠️ found a dupe`)
                  density()
                }
              }
              density()

              noOverlap.push(posArray)

              let starWidth
              if (isMobile && star.focus) {
                starWidth = getRandomNumber(50, 60)
              } else if (isMobile) {
                starWidth = getRandomNumber(20, 45)
              } else if (star.focus) {
                starWidth = getRandomNumber(100, 110)
              } else {
                starWidth = getRandomNumber(40, 70)
              }

              const position = {
                position: 'absolute',
                top: `${topPos}vh`,
                left: `${leftPos}vw`,
                width: `${starWidth}px`,
                height: `${starWidth}px`,
                display: star.press ? `none !important` : `flex`,
              }
              return <UsersList key={index} star={star} position={position} starWidth={starWidth} />
            })}
          </div>
        </div>
      </Fragment>
    )
  }
}
export default Users
